import React from "react";

/**
 * Optional full-width banner image pinned above the two-column activation
 * layout. Renders nothing when no image is configured — the corporate
 * activation page must keep working when this section is absent or empty.
 *
 * @param {{ section?: { image_url?: string } }} props
 */
const HeroImage = ({ section }) => {
  const url = section?.image_url;
  if (!url) return null;
  return (
    <img
      src={url}
      alt=""
      className="corp-hero-banner w-full max-h-[420px] object-cover rounded-2xl"
    />
  );
};

export default HeroImage;
